  var Backbone = require('backbone'),
      _ = require('underscore');

  // Define Application Events Object that will be exported from module
  var appEvents = _.extend({}, Backbone.Events);

  // Return exportable appEvents object
  module.exports = appEvents;
